import angular from 'angular';
import common from './common/common';
import views from './views/views';

/**
 * Components Main module
 */
export default angular.module('app.components', [common, views]).name;


// WEBPACK FOOTER //
// ./src/app/components/components.js